(() => {
  'use strict';
  const rails = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(scope = document) {
    scope.querySelectorAll('[data-wg-rail]').forEach(rail => {
      if (rails.has(rail)) return;
      const track = rail.querySelector('[data-wg-track]');
      const controls = rail.querySelector('[data-wg-controls]');
      if (!track || !controls) return;
      const previous = controls.querySelector('[data-wg-prev]');
      const next = controls.querySelector('[data-wg-next]');
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const count = controls.querySelector('[data-wg-count]');
      const nearest = () => {
        const children = Array.from(track.children);
        const start = track.getBoundingClientRect().left;
        return children.reduce((best, item, index) => Math.abs(item.getBoundingClientRect().left - start) < Math.abs(children[best].getBoundingClientRect().left - start) ? index : best, 0);
      };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = max < 3 || track.children.length < 2;
        previous.disabled = track.scrollLeft < 3;
        next.disabled = track.scrollLeft >= max - 3;
        if (count) count.textContent = `${next.disabled ? track.children.length : nearest() + 1} / ${track.children.length}`;
      };
      const move = direction => {
        const children = Array.from(track.children);
        const start = track.getBoundingClientRect().left;
        const target = children[Math.max(0, Math.min(children.length - 1, nearest() + direction))];
        if (target) track.scrollBy({ left: target.getBoundingClientRect().left - start, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
      rails.set(rail, () => { observer.disconnect(); controller.abort(); rails.delete(rail); });
    });
  }
  // Round timeline: the citrus rule fills and each step lights as its column scrolls past mid-screen,
  // so reading the routine feels like playing through the round. Without JS or with reduced motion it stays fully drawn.
  if (!reducedMotion.matches) {
    let frame = 0;
    const paint = () => {
      frame = 0;
      document.querySelectorAll('[data-wg-timeline]').forEach(list => {
        list.classList.add('is-tracking');
        const column = list.closest('.wg-lv-routine') || list;
        const box = column.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (innerHeight * .65 - box.top) / (box.height * .7)));
        list.style.setProperty('--wg-progress', progress.toFixed(3));
        const filled = progress * list.clientHeight;
        Array.from(list.children).forEach(step => step.classList.toggle('is-reached', filled >= step.offsetTop + 9));
      });
    };
    addEventListener('scroll', () => { frame ||= requestAnimationFrame(paint); }, { passive: true });
    addEventListener('resize', () => { frame ||= requestAnimationFrame(paint); });
    document.addEventListener('shopify:section:load', paint);
    paint();
  }
  // Fade the Klaviyo "GET 10% OFF" teaser while it covers the hero's "Featured in" logos.
  const press = document.querySelector('.wg-lv-hero-press');
  if (press) {
    let teaser, pending;
    const check = () => {
      pending = 0;
      if (!teaser?.isConnected) teaser = document.querySelector('[class*="kl-teaser-"]');
      if (!teaser) return;
      const a = press.getBoundingClientRect(), b = teaser.getBoundingClientRect();
      document.documentElement.classList.toggle('wg-lv-teaser-clear', a.bottom > b.top && a.top < b.bottom && a.right > b.left && a.left < b.right);
    };
    const queue = () => { pending ||= requestAnimationFrame(check); };
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue);
    document.addEventListener('transitionend', queue);
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-wg-rail]').forEach(rail => rails.get(rail)?.());
  });
  document.addEventListener('shopify:block:select', event => {
    const track = event.target.closest('[data-wg-track]');
    if (track) track.scrollBy({ left: event.target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'instant' });
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
})();
